<template>
  <thead class="table-header" :class="{ 'table-header--sticky': sticky }">
    <tr class="table-header__row">
      <th
        v-for="col in columns"
        :key="col.key"
        class="table-header__cell"
        :class="[
          { 'table-header__cell--sortable': col.sortable !== false },
          { 'table-header__cell--actions': col.actions },
          col.cellClass,
        ]"
        :style="col.width ? { width: col.width } : undefined"
        @click="col.sortable !== false ? onSort(col.key) : null"
      >
        <slot name="cell" :column="col">
          <span class="table-header__content">
            {{ col.label }}
            <span
              v-if="col.sortable !== false && sortKey === col.key"
              class="table-header__sort-icon"
              aria-hidden="true"
            >
              <ChevronUpIcon v-if="sortOrder === 'asc'" class="w-4 h-4" />
              <ChevronDownIcon v-else class="w-4 h-4" />
            </span>
          </span>
        </slot>
      </th>
    </tr>
  </thead>
</template>

<script setup>
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
  },
  sticky: { type: Boolean, default: true },
  sortKey: { type: String, default: '' },
  sortOrder: { type: String, default: 'asc', validator: (v) => ['asc', 'desc'].includes(v) },
});

const emit = defineEmits(['sort']);

function onSort(key) {
  emit('sort', key);
}
</script>

<style scoped>
.table-header {
  border-bottom: 1px solid transparent;
  background: var(--brand-navy);
}

.table-header--sticky {
  @apply sticky top-0 z-10;
  box-shadow: 0 1px 0 0 rgba(1, 38, 62, 0.2);
}

.table-header__row {
  @apply border-0;
}

.table-header__cell {
  @apply text-left px-6 py-3.5 font-semibold whitespace-nowrap;
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--paper);
}

.table-header__cell--sortable {
  @apply cursor-pointer select-none;
}

.table-header__cell--sortable:hover {
  color: rgba(255, 255, 255, 0.92);
}

.table-header__cell--actions {
  @apply text-right;
  min-width: 120px;
}

.table-header__content {
  @apply inline-flex items-center gap-1.5;
}

.table-header__sort-icon {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.9);
}
</style>
